export default {
  de: 'Deutsch',
  en: 'English',
  formattypes: {
    selection: 'Formatierung von Datumsfeldern',
    iso: 'ISO-Format (JJJJ-MM-TT SS:mm)',
    de: 'Deutsch (TT.MM.JJJJ SS:mm)',
    en: 'Englisch (MM/TT/JJJJ SS:mm)'
  },
  themes: {
    dark: 'Dunkel',
    light: 'Hell'
  },
  denses: {
    false: 'Normale Abstände',
    true: 'Kleine Abstände'
  },
  actions: {
    cancel: 'Abbrechen',
    ok: 'OK',
    save: 'Speichern',
    discard: 'Nicht speichern',
    close: 'Beenden',
    logout: 'Abmelden',
    all: 'Alle',
    apply: 'Übernehmen',
    go: 'Weiter',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    csv: 'Export nach CSV',
    import: 'Importieren',
    invite: 'Einladen',
    accept: 'Annehmen',
    clone: 'Duplizieren',
    reset: 'Formular zurücksetzen',
    undo: 'Rückgängig machen',
    send: 'Senden',
    export: 'Export',
    exportXlsx: 'Export nach XLSX',
    clear: 'Leeren',
    pdf: 'PDF erstellen',
    image: 'Bild erstellen',
    create: 'Erstellen',
    saveAndClose: 'Speichern & Schließen'
  },
  user: {
    loggedInAs: 'Angemeldet als',
    settings: 'Einstellungen',
    settingsMore: 'Benutzereinstellungen..'
  },
  options: {
    title: 'Benutzereinstellungen',
    messages: 'Nachrichten',
    hints: 'Hilfe',
    theme: 'Dunkle Oberfläche',
    dense: 'Kleinere Abstände',
    autoReload: 'Automatische Aktualisierung',
    themes: 'Farbdesign der Benutzeroberfläche',
    denses: 'Vergrößern oder verkleinern der Abstände der Oberflächenelemente',
    copies: 'CC und BCC für den E-Mail-Versand',
    cc: 'Kopie (CC) an',
    bcc: 'Blindkopie (BCC) an',
    emailHint: 'Geben Sie eine gültige E-Mail-Adresse ein und bestätigen die Eingabe mit Enter.',
    tree: {
      gui: 'Oberfläche',
      language: 'Sprache',
      dateformat: 'Datumsformat',
      theme: 'Farben',
      dense: 'Abstände',
      mailing: 'Mailing',
      copies: 'Kopien'
    }
  },
  locales: {
    selection: 'Sprachauswahl'
  },
  tour: {
    labels: {
      buttonSkip: 'Überspringen',
      buttonPrevious: 'Zurück',
      buttonNext: 'Nächster',
      buttonStop: 'Ende'
    }
  },
  routes: {
    home: 'Übersicht',
    organizations: 'Organisationen',
    staff: 'Mitarbeiter',
    templates: 'Vorlagen',
    coaching: 'Coachings',
    reporting: 'Reporting'
  },
  home: {
    finished: 'Durchgeführt',
    grade12: 'sehr gut, gut',
    grade34: 'befriedigend, ausreichend',
    grade56: 'nicht ausreichend',
    avgDuration: 'Dauer Durchschnitt',
    avgRating: 'Bewertung Durchschnitt',
    reminder: 'Wiedervorlagen',
    showExpired: 'Abgelaufene anzeigen',
    createdCoachings: 'Neu erstellte Coachings',
    finishedCoachings: 'Durchgeführte Coachings',
    lastHour: 'Letzte Stunde',
    lastDay: 'Letzte 24 Stunden',
    newLastHour: 'Neu',
    newLastDay: 'Neu',
    finishedLastHour: 'Durchgeführt',
    finishedLastDay: 'Durchgeführt',
    openSelection: 'Filter auswählen',
    averageTemplateRating: 'Durchschnittliche Bewertung pro Vorlage',
    createPDF: 'PDF von Übersicht erstellen',
    summaryTitle: 'Übersicht',
    pdfFilename: 'coaching-übersicht-{date}.pdf',
    createImage: 'Bild von Übersicht erstellen',
    imageFilename: 'coaching-übersicht-{date}.png',
    summaryProcessing: 'PDF wird erstellt. Einen Moment Geduld bitte...'
  },
  drawer: {
    changePassword: 'Passwort ändern',
    changelog: 'Änderungsübersicht',
    feedback: 'Feedback an Support',
    calendar: 'Kalendar anzeigen',
    adminPage: 'Administration'
  },
  organisation: {
    label: 'Organisationen',
    missingTitle: 'Sie sind noch keiner Organisation zugeordnet',
    missingText: 'Wechseln Sie zum Reiter ORGANISATIONEN und erstellen eine neue Organisation, welcher Sie dann automatisch zugeordnet werden.',
    selectHeader: 'IHRE ORGANISATIONEN',
    delete: 'Organisation wirklich löschen?',
    name: 'Name der Organisation',
    description: 'Beschreibung der Organisation',
    initials: 'Kürzel der Organisation',
    confirmDeleteHint: 'Dies ist eine Sicherheitsabfrage, damit Sie nicht versehentlich eine falsche Organisation löschen.',
    confirmInvalid: 'Name der Organisation stimmt nicht überein.',
    invite: 'Benutzer in Organisation einladen',
    inviteSuccess: 'Einladung wurde versendet',
    email: 'E-Mail des Benutzers',
    emailHint: 'Für einen Benutzer, der noch nicht existiert, wird eine Registrierung durchgeführt.',
    emailEmpty: 'E-Mail ist ein Pflichtfeld',
    emailInvalid: 'E-Mail ist nicht gültig',
    create: 'Organisation erstellen',
    edit: 'Organisation bearbeiten',
    deleteLabel: 'Geben Sie hier den Namen der Organisation ein',
    selection: {
      title: 'Organisationen auswählen',
      titleSingle: 'Organisation auswählen',
      copyHint: 'In welche Organisationen soll die Vorlage kopiert werden?',
      createHint: 'In welcher Organisation soll das Coaching erstellt werden?'
    }
  },
  template: {
    label: 'Vorlagen',
    created: 'Neue Vorlage',
    delete: 'Vorlage wirklich löschen?',
    missingConfigTitle: 'Speichern nicht möglich',
    missingConfigText: 'Es sind keine Bausteine vorhanden.',
    create: 'Vorlage erstellen',
    edit: 'Vorlage bearbeiten',
    metadata: 'Beschreibung',
    blocks: 'Bausteine',
    buildingBlocks: 'Bausteingruppe',
    exists: 'vorhanden',
    initialsAutoPrefix: 'VORLAGE-',
    blockCreated: 'Neuer Baustein wurde gespeichert',
    confirmCancelTitle: 'Ihre Änderungen speichern?',
    confirmCancelDescription: 'Die Vorlage wurde bearbeitet.',
    copied: 'Vorlage wurde kopiert!',
    saved: 'Vorlage wurde gespeichert!'
  },
  employee: {
    label: 'Mitarbeiter',
    organizationGroup: 'Gruppe',
    organizationGroupHint: 'Abhängig von der gewählten Gruppe bekommt der Mitarbeiter unterschiedliche Berechtigungen',
    username: 'Mitarbeiter',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    isActive: 'Aktiv',
    all: 'Alle',
    active: 'Nur Aktive',
    inactive: 'Nur Inaktive',
    delete: 'Mitarbeiter wirklich löschen?',
    import: 'Mitarbeiter importieren',
    importText: 'Anlage von Mitarbeitern per Text- oder Dateiimport',
    importHint: 'Komma oder Semikolon getrennt (Gruppe, E-Mail, Benutzername, Vorname, Nachname). Pro Mitarbeiter eine Zeile.',
    created: 'Neue Mitarbeiter angelegt',
    create: 'Mitarbeiter erstellen',
    edit: 'Mitarbeiter bearbeiten',
    invite: 'Einladung per E-Mail verschicken',
    added: 'Mitarbeiter angelegt',
    invitations: 'Einladungen',
    inviteDelete: 'Einladung wirklich löschen?',
    organizationItemText: 'Bei welcher Gruppe eine Einladungs- oder Registrierungsmail verschickt wird'
  },
  groups: {
    EmployeeDumb: 'Mitarbeiter ohne Login',
    EmployeeSane: 'Mitarbeiter mit E-Mail',
    EmployeeSmart: 'Mitarbeiter mit Login',
    Administrator: 'Administrator',
    Coach: 'Coach',
    Disabled: 'Deaktiviert'
  },
  coaching: {
    preview: 'Vorschau',
    planning: 'Coaching planen',
    selectEmployee: 'Mitarbeiter auswählen',
    hintEmployee: 'Für welche Mitarbeiter soll das Coaching durchgeführt werden? (nur aktive Mitarbeiter stehen zur Auswahl)',
    noEmployee: 'Keine Mitarbeiter vorhanden',
    selectTemplate: 'Vorlage auswählen',
    hintTemplate: 'Mit welcher Vorlage soll das Coaching erstellt werden?',
    delete: 'Coaching wirklich löschen?',
    edit: 'Coaching wirklich bearbeiten?',
    editHint: 'Coaching wurde bereits als durchgeführt gekennzeichnet.',
    clone: 'Coaching wirklich duplizieren?',
    cloneHint: 'Mitarbeiter und Vorlage werden übernommen und ein neues Coaching wird erstellt.',
    summaryProcessing: 'PDF wird erstellt. Einen Moment Geduld bitte...',
    summaryTitle: 'Coaching Zusammenfassung',
    finishAction: 'Coaching durchgeführt',
    finishActionError: 'Es sind Bausteine vorhanden, die noch keine gültige Eingabe haben!',
    finishMessage: 'Coaching als durchgeführt kennzeichnen?',
    finishDescription: 'Das Coaching wird ausgeblendet und in den Statistiken auf der Übersichtsseite berücksichtigt.',
    finishSubmit: 'Kennzeichnen',
    confirmCancelTitle: 'Ihre Änderungen speichern?',
    confirmCancelDescription: 'Das Coaching wurde bearbeitet.',
    newTextOne: 'Es wurde ein neues Coaching erstellt',
    newText: 'Es wurden <% len %> neue Coachings erstellt',
    open: 'Coaching anzeigen',
    pdfFilename: 'coaching-zusammenfassung-{date}.pdf',
    imageFilename: 'coaching-zusammenfassung-{date}.png',
    pdfFilenamePlanning: 'coaching-planung-{date}.pdf',
    imageFilenamePlanning: 'coaching-planung-{date}.png',
    pdfSelectionTitle: 'Auswahl für PDF-Erstellung',
    pdfSelectionDescription: '',
    pdfWithRadar: 'Netzdiagramm anhängen?',
    pdfWithNoRating: 'Bausteine ohne Bewertung anzeigen?',
    startTimer: 'Stoppuhr starten',
    stopTimer: 'Stoppuhr anhalten',
    resetTimer: 'Stoppuhr zurücksetzen',
    undoResetTimer: 'Zurücksetzen rückgängig machen',
    search: 'Coachings suchen',
    noRatingHintShort: 'KB',
    noRatingHint: 'KB = keine Bewertung',
    emailSent: 'E-Mail wurde versendet',
    saved: 'Coaching wurde gespeichert!'
  },
  compare: {
    title: 'Coachings vergleichen',
    actions: {
      collapseAll: 'Alle einklappen',
      expandAll: 'Alle ausklappen',
      radar: 'Radar',
      toggleRadar: 'Radar ein-/ausblenden'
    }
  },
  cas: {
    label: 'Erweiterte Suche'
  },
  entity: {
    user: 'Benutzer',
    initials: 'Kürzel',
    name: 'Name',
    description: 'Beschreibung',
    employee: 'Mitarbeiter',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    isActive: 'Aktiv',
    finished: 'Durchgeführt',
    finishedFrom: 'Durchgeführt durch',
    finishedDate: 'Durchgeführt am',
    finishedTime: 'Durchgeführt um',
    template: 'Vorlage',
    result: 'Ergebnis',
    duration: 'Dauer',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    filter: 'Filtern nach...',
    process: 'Durchführen',
    created: 'Erstellt am',
    view: 'Anzeigen',
    clone: 'Duplizieren',
    date: 'Datum',
    time: 'Uhrzeit',
    summary: 'Zusammenfassung',
    weighting: 'Gewichtung',
    rating: 'Bewertung',
    timer: 'Stoppuhr',
    ratingWeighted: 'Bewertung gewichtet',
    sheet: 'Scorecards',
    report: 'Auswertung',
    total: 'Gesamt',
    note: 'Note',
    totalweighted: 'Gesamt gewichtet',
    noteweighted: 'Note gewichtet',
    error: 'Fehler',
    reminder: 'Wiedervorlage',
    scriptureUser: 'Unterschrift Benutzer',
    scriptureEmployee: 'Unterschrift Mitarbeiter',
    group: 'Gruppe',
    invitation: 'Einladung',
    expires: 'Gültig bis',
    expiresFromNow: 'von jetzt',
    pending: 'Ausstehend',
    state: 'Status',
    link: 'Link',
    private: 'Privat',
    pdf: 'PDF',
    pdfcreate: 'PDF erzeugen',
    print: 'Drucken',
    send: 'Senden',
    sort: 'Sortierung',
    asc: 'aufsteigend',
    desc: 'absteigend',
    copy: 'Kopieren',
    average: 'Durchschnitt',
    compare: 'Vergleichen',
    voixenid: 'ID der Aufnahme aus der VIER Interaction Analytics',
    voixenuser: 'VIER Benutzer',
    summaryBuildingBlocks: 'Summierung Bausteingruppen',
    blocks: 'Bausteine'
  },
  coachingUnit: {
    label: 'Coaching-Einheiten',
    create: 'Coaching-Einheit erstellen',
    edit: 'Coaching-Einheit bearbeiten',
    delete: 'Coaching-Einheit wirklich löschen?',
    setDone: 'Als abgeschlossen markieren?',
    setDoneHint: 'Diese Aktion ist unwiderruflich. Danach können keine Coachings mehr hinzugefügt oder bearbeitet werden.',
    setDoneSubmit: 'Abschließen',
    isDone: 'Abgeschlossen',
    isOpen: 'Offen',
    name: 'Name der Einheit',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    score: 'Bewertung',
    addCoaching: 'Coaching hinzufügen',
    noCoachings: 'Keine Coachings in dieser Einheit',
    selectEmployee: 'Mitarbeiter auswählen',
    saved: 'Coaching-Einheit wurde gespeichert!'
  },
  notes: {
    name: 'Bemerkungen',
    initials: 'NOTIZEN',
    description: 'Zur internen Verwendung',
    private: 'Bemerkungen nur für den Coach ersichtlich?'
  },
  register: {
    label: 'Registrierung',
    username: 'Benutzername',
    password: 'Passwort',
    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    agree: 'Ich stimme den Nutzungsbedingungen zu',
    submit: 'Registrierung durchführen',
    pwTitle: 'Wählen Sie ein Passwort aus',
    toastTitle: 'Registrierung erfolgreich durchgeführt',
    toastText: 'Mit Erhalt der Aktivierungsmail schließen Sie den Vorgang ab.',
    termsofuse: 'hier aufrufen',
    oldPw: 'Altes Passwort',
    oldPwHint: 'Damit nur Sie ein neues Passwort vergeben können, geben Sie ihr altes Passwort ein.',
    newPw: 'Neues Passwort',
    newPwHint: 'Eingabe muß mindestens 8 Zeichen lang sein, einen Großbuchstaben und eine Zahl enthalten.',
    pwHintIntro: 'Eingabe muß mindestens 8 Zeichen lang sein,',
    pwHintAlphaLower: 'einen Kleinbuchstaben',
    pwHintAlphaUpper: 'einen Großbuchstaben',
    pwHintNumber: 'eine Zahl',
    pwHintSpecial: 'ein Sonderzeichen (mit Ausnahme von + und %)',
    pwHintEnd: 'enthalten.',
    newPwInvalid: 'Das Passwort muss mindestens einen Großbuchstaben und eine Zahl enthalten.',
    newPwConfirm: 'Neues Passwort bestätigen',
    newPwConfirmHint: 'Zur Sicherheit und Vermeidung von Falscheingaben, geben Sie das Passwort erneut ein.',
    usernameExists: 'Der Benutzername ist bereits vergeben.',
    failedTitle: 'Registrierung fehlgeschlagen',
    failedSubtitle: 'Registrierung bereits abgeschlossen oder Link ist nicht mehr gültig.',
    processingTitle: 'Registrierung wird abgeschlossen',
    processingSubtitle: 'Einen Moment Geduld bitte...',
    doneTitle: 'Registrierung wurde abgeschlossen',
    doneSubtitle: 'Sie können sich jetzt anmelden.'
  },
  password: {
    oldLabel: 'Altes Passwort',
    newLabel: 'Neues Passwort',
    confirmLabel: 'Neues Passwort bestätigen',
    confirmHint: 'Zur Sicherheit und Vermeidung von Falscheingaben, geben Sie das Passwort erneut ein.',
    changed: 'Passwort wurde geändert'
  },
  login: {
    label: 'Anmeldung',
    username: 'Benutzername / E-Mail',
    password: 'Passwort',
    submit: 'Anmelden',
    authError: 'Anmeldung ist fehlgeschlagen!',
    resetPassword: 'Passwort vergessen',
    resetPasswordSuccess: 'E-Mail wurde an den Benutzer gesendet'
  },
  app: {
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    toc: 'Nutzungsbedingungen',
    agb: 'AGB',
    disclaimer: 'Haftungsausschluss'
  },
  settings: {
    startTour: 'Mini-Tutorial starten',
    showMessages: 'Nachrichten anzeigen'
  },
  search: {
    noFilter: 'Alle',
    activeFilter: 'Aktive Filter',
    ignoreFinished: 'Alle Coachings anzeigen',
    finished: 'Durchgeführte Coachings anzeigen',
    notFinished: 'Nicht durchgeführte Coachings anzeigen',
    periodOfTime: 'Zeitraum',
    periodOfTimeCreated: 'Erstellt',
    periodOfTimeFinished: 'Durchgeführt',
    from: 'ab',
    until: 'bis',
    employees: 'Mitarbeiter',
    coach: 'Coach',
    contains: 'enthält',
    filtertext: 'Filtern nach..',
    durationRating: 'Dauer und Bewertung',
    rangeCreated: 'Zeitraum für neu angelegte Coachings',
    rangeFinished: 'Zeitraum für durchgeführte Coachings',
    datefrom: 'Startdatum',
    timefrom: 'Startzeit',
    dateto: 'Enddatum',
    timeto: 'Endzeit',
    templates: 'Vorlagen',
    blocks: 'Bausteingruppen',
    durationfrom: 'Dauer von',
    durationto: 'Dauer bis',
    ratingfrom: 'Bewertung von',
    ratingto: 'Bewertung bis',
    saveTitle: 'Suche speichern',
    saveName: 'Name der Suche',
    saveSelect: 'Suche auswählen',
    relTime: {
      title: 'Zeitraum',
      all: 'Alle',
      today: 'Heute',
      yesterday: 'Gestern',
      thisWeek: 'Diese Woche',
      lastWeek: 'Letzte Woche',
      thisMonth: 'Dieser Monat',
      lastMonth: 'Letzter Monat',
      last2Month: 'Letzte 2 Monate',
      last3Month: 'Letzte 3 Monate',
      last6Month: 'Letzte 6 Monate',
      thisYear: 'Dieses Jahr',
      lastYear: 'Letztes Jahr'
    }
  },
  reporting: {
    tempMessage: 'Im Februar 2020 finden Sie hier die Auswertungen der durchgeführten Coachings.',
    title: 'Steigerung der Mitarbeiter-Produktivität durch gezieltes Coaching',
    xLabel: 'Monat',
    yLabel: 'Bewertung',
    ds1Label: 'Ergebnis ihrer Mitarbeiter',
    ds2Label: 'vor dem Einsatz von VIER Scorecards',
    treemapEmployee: 'Durchgeführte Coachings je Mitarbeiter und Vorlage',
    treemapTemplate: 'Durchgeführte Coachings je Vorlage und Mitarbeiter',
    treemapAll: 'Alle vorhandenen Coachings',
    linechartTitle: 'Coaching-Entwicklung',
    soEmpty: 'Leider keine durchgeführten Coachings zur Auswertung vorhanden!',
    templatesHint: 'Für welche Vorlage möchten Sie die Entwicklung sehen?',
    actions: {
      collapseAll: 'Alle einklappen',
      expandAll: 'Alle ausklappen'
    }
  },
  messages: {
    title: 'Nachrichten',
    acceptInvitation: 'Einladung annehmen',
    expiredInvitation: 'Einladung',
    expiredLink: 'Dieser Link ist abgelaufen und kann nicht mehr verwendet werden!',
    emailInvalid: 'E-Mail ist nicht gültig'
  },
  gf: {
    firstname: 'Vorname',
    lastname: 'Nachname',
    street: 'Straße',
    housenumber: 'Hausnummer',
    zipcode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    county: 'Landkreis',
    phone: 'Telefonnummer',
    email: 'E-Mail',
    duration: 'Dauer',
    adult: 'Über 18 Jahre?',
    rating: 'Bewertung',
    combo: 'Hobby',
    comment: 'Kommentar',
    info: 'Information',
    date: 'Datum',
    required: '* = Pflichtfeld',
    optional: 'Optional'
  },
  teaser: {
    text1: 'Mitarbeitercoachings digital erstellen, planen und durchführen.',
    text2: 'Frei konfigurierbare Formulare, intuitive Vorlagen,',
    text3: 'übersichtliche Mitarbeiterlisten und flexible Auswertungen',
    text4: 'machen es einfacher als jemals zuvor,',
    text5: 'bei der Entwicklung Ihrer Mitarbeiter',
    text6: 'den entscheidenden Schritt voraus zu sein.'
  },
  offer: {
    headline: 'Digitaler Coachingbogen',
    subtitle: 'In 5 Minuten zum digitalisierten Coachingprozess! Ab 5€ im Monat.',
    primary: 'Jetzt kostenlos und unverbindlich 30 Tage testen*',
    footer: '* Die Testphase endet automatisch nach 30 Tagen. Sie entscheiden dann selbst, ob und wie Sie weitermachen möchten.'
  },
  cancelled: 'Abbruch',
  errors: {
    title: 'Problem',
    defaultMessage: 'Es ist ein unerwarteter Fehler aufgetreten!',
    status403Message: 'Der Zugriff wurde verweigert!'
  }
}
